import { Injectable } from '@angular/core';
import * as Handlebars from 'handlebars';

@Injectable({
  providedIn: 'root'
})
export class SclHandlebarsService {

  constructor() {
  }


/////////

  initHandlebars(helpers) {
      // Adding some standard helpers
      // Comparison
      Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
          return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
      });
      Handlebars.registerHelper('ifNotEquals', function(arg1, arg2, options) {
          return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
      });
      Handlebars.registerHelper('switch', function(value, options) {
        this.switch_value = value;
        this.switch_break = false;
        return options.fn(this);
      });
      Handlebars.registerHelper('case', function(value, options) {
        if (value == this.switch_value) {
          this.switch_break = true;
          return options.fn(this);
        }
      });
      Handlebars.registerHelper('default', function(value, options) {
         if (this.switch_break == false) {
           return value;
         }
      });
      // Date handling
      // Handlebars.registerHelper('dateFormat', (date, format, options) => moment(date).format(format));
      // Handlebars.registerHelper('dateAdd', (date, amount, what, options) => moment(date).add(amount, what).format());
      // Handlebars.registerHelper('dateFromNow', (date, options) => moment(date).fromNow());
      // Handlebars.registerHelper('dateToNow', (date, options) => moment(date).toNow());
      // Handlebars.registerHelper('dateCalendar', (date, options) => moment(date).calendar());


      // If component has helpers defined add them in too
      if (typeof helpers !== 'undefined' && helpers !== null ) {
        for (let i = 0; i < helpers.length ; i++) {
            if (typeof helpers[i].name === 'string' && typeof helpers[i].function === 'string') {
                let helpFunc;
                eval('helpFunc = '+ helpers[i].function);
                Handlebars.registerHelper(helpers[i].name, helpFunc);
            }
        }
      }
      // console.log("%c initHandlebars, registerHelper :", 'color:blue');
      // console.log(Handlebars.helpers);
  }

  checkRegistedHelpers(helpers) {
      if (!helpers) { return; }
      // console.log('%c ibefore checkRegistedHelpers : ', 'color:blue');
      // console.log(Handlebars.helpers);
      let isRegistered = true;
      for (let i = 0; i < helpers.length ; i++) {
          if (typeof helpers[i].name === 'string' && typeof helpers[i].function === 'string') {
              if (!(helpers[i].name in Handlebars.helpers)) {
                  isRegistered = false;
                  break;
              }
          }
      }
      if (!isRegistered) {
          this.initHandlebars(helpers);
      }
  }

processHandlebars(handlebarsString, data, helpers) {
    //   this.checkRegistedHelpers(helpers);
    // if(handlebarsString == null) return "";
    // var hStr;
    // if(typeof handlebarsString === "string")
    //     hStr = handlebarsString;
    // else
    //     hStr = JSON.stringify(handlebarsString);

    // // begin : 14274
    // var handlebarsContext = {
    //     document: this.document, // the fields from the current document
    //     doc: scope.doc, // a duplicate for compatibility of document
    //     account: scope.account, // the account document from scope
    //     tpl: scope.tpl, // the template for the current document
    //     tplItem: scope.tplItem // the current components configuration details
    //   };
    //   var invalidField = ["document", "doc", "account", "tpl", "tplItem", "results", "resultsCount", "resultsIndex", "result", "row"];
    //   if(data){
    //       if(Object(data) === data){ // if the second parameter is object has property
    //           for(var f in data){
    //               if(f === "queryResultDocument"){
    //                   handlebarsContext["row"] = data[f];
    //                   handlebarsContext["result"] = data[f];
    //                   for(var j in data[f]){
    //                       if(invalidField.indexOf(j) > -1){
    //                           logger.info("Handlebars Context Error: the field " + j + " is already present in document documentId so could not be set. It's values will NOT be available to handlebars expressions. Please advise your Application Developer to not use this field name if possible");
    //                           continue;
    //                       }
    //                       handlebarsContext[j] = data[f][j];
    //                   }

    //               }
    //               else{
    //                   if(handlebarsContext.hasOwnProperty(f)){
    //                       logger.info("Handlebars Context Error: the field " + f + " is already present in document documentId so could not be set. It's values will NOT be available to handlebars expressions. Please advise your Application Developer to not use this field name if possible");
    //                           continue;
    //                   }
    //                   handlebarsContext[f] = data[f];
    //               }
    //           }
    //       }
    //       else{
    //           logger.info("Handlebars Context Error: object " + data + " wasn't passed in and the parameters is being ignored");
    //       }
    //   }
    // // end : 14274
    // //console.log('handlebarsContext = ' + JSON.stringify(handlebarsContext));
    // var result = null;
    // try{
    //     // console.log(Handlebars.helpers);
    //     var template = Handlebars.compile(hStr);
    //       result = template(handlebarsContext);
    // }
    // catch(err){
    //       err.hStr = hStr;
    //     logger.info(err);
    // }

    //   return result;
    return;
  }

  processIntHandlebars(handlebarsString, data, helpers) {
      // const hStr = this.processHandlebars(handlebarsString, data, helpers);

      // if (hStr) {
      //     return parseInt( hStr );
      // } else {
      //   return 0;
      // }
  }

  processFloatHandlebars(handlebarsString, data, helpers) {
    //   var hStr = this.processHandlebars(handlebarsString, data, helpers);
    //   if(hStr){
    //       return parseFloat( hStr );
    //   }
    // else return 0;
  }

  processBooleanHandlebars(handlebarsString, data, helpers) {
    // return  this.processHandlebars(handlebarsString, data, helpers) === 'true';
  }

  processArrayHandlebars(handlebarsString, data, helpers) {
      // var hStr = this.processHandlebars(handlebarsString, data, helpers);
      // if(hStr){
      //     try{
      //         var obj = JSON.parse( hStr );
      //         var arr = [];
      //         for(var i in obj){
      //             arr.push(obj[i]);
      //         }
      //         return arr;
      //     }
      //     catch(err){
      //         return null;
      //     }
      // }
      // else{
      //     return null;
      // }
}



/////////



}
